declare const DEMO_USERNAME: string;
declare const IS_IMPERSONATED_SESSION: boolean;

const hostname = window.location.hostname;
const pathname = window.location.pathname;

export const IS_ADMIN =
  (hostname === "admin.buttondown.com" ||
    hostname === "127.0.0.1" ||
    hostname === "localhost" ||
    hostname.endsWith(".bd")) &&
  !pathname.includes("/vue-storybook/");

export const IS_DEMO =
  !import.meta.env.VITEST &&
  typeof DEMO_USERNAME !== "undefined" &&
  DEMO_USERNAME !== "" &&
  !IS_ADMIN;

export const IS_IMPERSONATED =
  typeof IS_IMPERSONATED_SESSION !== "undefined" && IS_IMPERSONATED_SESSION;
